import { blockquote as blockquoteFactory } from '../../next-schema/generated/nodeTypes';
import { blockquoteLegacy as blockquoteLegacyFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils';

/**
 * @name blockquote_node
 */

const nodeSpecOptions = {
  parseDOM: [{
    tag: 'blockquote'
  }],
  toDOM() {
    return ['blockquote', 0];
  }
};
export const blockquote = blockquoteLegacyFactory(nodeSpecOptions);

/**
 * @name extentedBlockquote
 * @description the block quote node with nested code block, media, and extension
 */
export const extendedBlockquote = blockquoteFactory(nodeSpecOptions);
const nodeSpecOptionsWithLocalId = {
  parseDOM: [{
    tag: 'blockquote',
    getAttrs: () => {
      return {
        localId: uuid.generate()
      };
    }
  }],
  toDOM(node) {
    var _node$attrs;
    return ['blockquote', {
      'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
    }, 0];
  }
};
export const extendedBlockquoteWithLocalId = blockquoteFactory(nodeSpecOptionsWithLocalId);